<template>
  <div class="four">
    <div class="con container">
      <h2 :class="['title', activeIndex === 3 ? 'animated fadeInUp' : '']">
        我们的社会责任
      </h2>
      <div
        :class="['out_container', activeIndex === 3 ? 'animated fadeInUp' : '']"
      >
        <div class="home_in_container">
          <div class="swiper-wrapper self-container">
            <div
              class="item swiper-slide"
              v-for="(v, i) in list"
              :key="i"
              @click="toSocial(v.id)"
            >
              <div class="card">
                <div class="item-img">
                  <img :src="v.image" alt />
                  <div class="item-title">{{ v.title }}</div>
                </div>
                <div class="item-con" v-html="v.intro">{{ v.content }}</div>
              </div>
            </div>
          </div>
          <div class="btn">
            <div class="swiper-button-prev" @click="change('prev')">
              <div v-show="!forbiddenLeft" class="use">
                <img
                  v-if="btn.left"
                  src="@/assets/images/left-light-3.png"
                  alt
                />
                <img v-else src="@/assets/images/left-3.png" alt />
              </div>
              <img
                v-show="forbiddenLeft"
                class="cantuse"
                src="@/assets/images/no-left.png"
                alt
              />
            </div>
            <div class="swiper-button-next" @click="change('next')">
              <div v-show="!forbiddenRight" class="use">
                <img
                  v-if="btn.right"
                  src="@/assets/images/right-light-3.png"
                  alt
                />
                <img v-else src="@/assets/images/right-3.png" alt />
              </div>
              <img
                v-show="forbiddenRight"
                class="cantuse"
                src="@/assets/images/no-right.png"
                alt
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <Footer />
    </div>
  </div>
</template>
<script>
import { Swiper } from "vue-awesome-swiper";
import Footer from "@/components/footer.vue";
import { getDutyList } from "@/libs/api";
export default {
  data() {
    return {
      mySwiper: {},
      btn: {
        left: false, //左边按钮高亮
        right: false //右边按钮高亮
      },
      forbiddenRight: false, //禁用右边
      forbiddenLeft: true, //禁用左边
      list: [
        {
          img: require("../../assets/images/four1.png"),
          title: "百日行公益",
          con:
            "习惯百日行的路上有爱同行，公益行动的开启，意味着孩子的每一次坚持，都有了更特别的意义。"
        },
        {
          img: require("../../assets/images/four2.png"),
          title: "免费家庭教育主题讲座",
          con:
            "心田花开一直在坚持举办免费家庭教育主题讲座，与家长沟通教育方法，希望在孩子成长之路上助一臂之力，截至目前已在全国开设千余场。"
        },
        {
          img: require("../../assets/images/four3.png"),
          title: "雷海为系列传统文化活动",
          con:
            "中国诗词大会第三季总冠军雷海为所带领的游园会、诗词沙龙等传统文化活动，心田花开希望通过活动，让孩子们成为优秀的传统文化传承者..."
        },
        {
          img: require("../../assets/images/four1.png"),
          title: "百日行公益",
          con:
            "习惯百日行的路上有爱同行，公益行动的开启，意味着孩子的每一次坚持，都有了更特别的意义。"
        },
        {
          img: require("../../assets/images/four2.png"),
          title: "免费家庭教育主题讲座",
          con:
            "心田花开一直在坚持举办免费家庭教育主题讲座，与家长沟通教育方法，希望在孩子成长之路上助一臂之力，截至目前已在全国开设千余场。"
        },
        {
          img: require("../../assets/images/four3.png"),
          title: "雷海为系列传统文化活动",
          con:
            "中国诗词大会第三季总冠军雷海为所带领的游园会、诗词沙龙等传统文化活动，心田花开希望通过活动，让孩子们成为优秀的传统文化传承者..."
        }
      ]
    };
  },
  components: {
    Footer
  },
  mounted() {
    this.swiperInit();
    this.getMsg();
  },
  computed: {
    activeIndex() {
      return this.$store.state.activeIndex;
    }
  },
  methods: {
    swiperInit() {
      let that = this;
      this.mySwiper = new Swiper(".home_in_container", {
        slidesPerView: 3,
        spaceBetween: 30,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        on: {
          slideChange: function() {
            if (this.activeIndex === 0) {
              that.forbiddenLeft = true;
              that.forbiddenRight = false;
            }
            if (this.activeIndex != 0) {
              that.forbiddenLeft = false;
            }
          },
          reachEnd: function() {
            that.forbiddenRight = true;
            that.forbiddenLeft = false;
          }
        }
      });
    },
    change(params) {
      console.log(params);

      if (params === "prev") {
        this.mySwiper.slidePrev();
        this.btn.left = true;
        this.btn.right = false;
      } else {
        this.mySwiper.slideNext();
        this.btn.left = false;
        this.btn.right = true;
      }
    },
    toSocial(id) {
      let routeUrl = this.$router.resolve({
        path: "/social",
        query: { id: id }
      });
      window.open(routeUrl.href, "_blank");
    },
    getMsg() {
      getDutyList({ status: 1 }).then(res => {
        console.log("message:", res.data.data);
        this.list = res.data.data;
      });
    }
  }
};
</script>
<style lang="less">
.four {
  width: 100vw;
  background: rgba(255, 255, 255, 1);
  .swiper-button-next,
  .swiper-button-prev {
    background: none;
  }
  .con {
    height: 70%;
    padding-top: 90px;
    background: rgba(255, 255, 255, 1);
    position: relative;
    .title {
      width: 100%;
      position: absolute;
      top: 10%;
      margin: 0;
      margin-top: 100px;
      padding: 0;
      font-size: 40px;
      font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
        sans-serif;
      font-weight: bold;
      line-height: 68px;
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .out_container {
      margin: 15% auto 0;
      width: 100%;
      overflow: hidden;
      position: relative;
      animation-delay: 0.3s;
    }
    .home_in_container {
      width: 90%;
      margin: 0 auto;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn {
        width: 100%;
        height: 44px;
        position: absolute;
        top: 36%;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    // slide高度适配
    /*版心*/
    @media screen and (min-width: 1440px) {
      .swiper-slide {
        height: 430px;
      }
      .btn {
        bottom: -73px;
      }
    }
    @media screen and (max-width: 1440px) and (min-width: 1280px) {
      .swiper-slide {
        height: 310px;
      }
      .btn {
        bottom: -43px;
      }
    }
    @media screen and (max-width: 1280px) {
      .swiper-slide {
        height: 310px;
      }
      .btn {
        bottom: -43px;
      }
    }
    .self-container {
      height: 528px;
      margin-top: 60px;
    }
    .item {
      width: 30%;
      border-radius: 16px;
      .card {
        width: 100%;
        height: 100%;
        border-radius: 16px;
        position: absolute;
        cursor: pointer;
        background: rgba(255, 255, 255, 1);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .item-img {
        height: 55%;
        margin: 6% 5%;
        position: relative;

        img {
          height: 100%;
        }
        .item-title {
          position: absolute;
          bottom: 0;
          left: 0;
          font-size: 20px;
          font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
            sans-serif;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          width: 100%;
          height: 59px;
          line-height: 59px;
          // 超出显示省略号
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(128, 128, 128, 1) 100%
          );
        }
      }

      .item-con {
        margin: 0 20px;
        text-align: center;
        font-size: 14px;
        font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
          sans-serif;
        font-weight: 400;
        line-height: 24px;
        color: rgba(96, 98, 102, 1);
        word-wrap: break-word;
        word-break: break-all;
        //多行文本溢出显示省略号
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        flex-direction: column;
      }
      &:hover .card {
        transform: translateY(-24px);
        transition-duration: 1.5s;
        transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 8px 16px rgba(204, 204, 204, 0.2);
      }
    }
  }
  //
  .foot {
    width: 100%;
    // height: 365px;
  }
  //
}
</style>
